import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    fetch("/api/admin/session.php", { credentials: "include" })
      .then((r) => r.json())
      .then((j) => {
        if (j.ok) navigate("/admin", { replace: true });
      })
      .catch(() => {});
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await fetch("/api/admin/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ password }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j.ok) {
        setErr(j.detail || "Autentificare eșuată.");
        return;
      }
      navigate("/admin", { replace: true });
    } catch {
      setErr("Nu s-a putut contacta serverul.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#1a1514] text-[#f5f0ee]">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm space-y-6 rounded-2xl border border-white/10 bg-black/30 p-8"
      >
        <div>
          <h1 className="text-lg font-semibold tracking-tight">Admin Social Destiny</h1>
          <p className="mt-2 text-sm text-white/50">Acces doar prin URL-ul /admin — nu există link pe site.</p>
        </div>
        <label className="block text-sm">
          <span className="text-white/60">Parolă</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full rounded-lg border border-white/15 bg-black/40 px-3 py-2 text-[15px] outline-none focus:ring-2 focus:ring-[#fbd9e5]/40"
          />
        </label>
        {err ? <p className="text-sm text-red-400">{err}</p> : null}
        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-full bg-[#fbd9e5] py-3 text-sm font-semibold text-[#3e2723] disabled:opacity-50"
        >
          {loading ? "Se conectează…" : "Intră"}
        </button>
      </form>
    </div>
  );
}
